import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import {
  formatInterviewSlotDateForDisplay,
  formatInterviewSlotTimeForDisplay
} from 'components/InterviewScheduler/utils/interviewSlotFormatting';

import { selectAppLocale } from 'features/locale/localeSelectors';

import { deserializeSlot } from 'utils/dateUtils';

import { InterviewSlotSerialized } from 'types/interviewSlots';

import styles from './SelectedSlot.module.scss';

interface SelectedSlotProps {
  slot: InterviewSlotSerialized;
}

const SelectedSlot: FC<SelectedSlotProps> = ({ slot }) => {
  const { t } = useTranslation();
  const appLocale = useSelector(selectAppLocale);

  const slotDate = deserializeSlot(slot);
  const formatSlotDate = (date: Date) =>
    formatInterviewSlotDateForDisplay(date, appLocale);
  const formatSlotTime = (date: Date) =>
    formatInterviewSlotTimeForDisplay(date, appLocale);

  return (
    <div className={styles.slotItem}>
      <div className={styles.slotContent}>
        <div className={styles.slotDate}>
          <span className={styles.dateValue}>
            {formatSlotDate(slotDate.start)}
          </span>
          <span className={styles.dateLabel}>
            {t('common.label.interviewDate')}
          </span>
        </div>
        <div className={styles.slotTime}>
          <span className={styles.timeValue}>
            {formatSlotTime(slotDate.start)}
          </span>
          <span className={styles.timeLabel}>
            {t('common.label.interviewTime')}
          </span>
        </div>
      </div>
    </div>
  );
};

export default SelectedSlot;
